import { toDisplayString as _toDisplayString, createVNode as _createVNode, renderSlot as _renderSlot, withModifiers as _withModifiers, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-2d9eb900")

_pushScopeId("data-v-2d9eb900")
const _hoisted_1 = { class: "dialog" }
const _hoisted_2 = {
  key: 0,
  class: "dialog__header"
}
const _hoisted_3 = { class: "header__title" }
const _hoisted_4 = { class: "header__extra" }
const _hoisted_5 = { class: "header__buttons" }
const _hoisted_6 = { class: "dialog__body" }
const _hoisted_7 = { class: "dialog__footer" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  return (_openBlock(), _createBlock("div", _hoisted_1, [
    (_ctx.showHeader)
      ? (_openBlock(), _createBlock("div", _hoisted_2, [
          _createVNode("div", _hoisted_3, _toDisplayString(_ctx.headerTitle), 1),
          _createVNode("div", _hoisted_4, [
            _renderSlot(_ctx.$slots, "headerExtra", {}, undefined, true)
          ]),
          _createVNode("div", _hoisted_5, [
            _createVNode("i", {
              class: "dialog__close icon-cancel",
              onClick: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (_ctx.$emit('close')), ["stop"]))
            })
          ])
        ]))
      : _createCommentVNode("", true),
    _createVNode("div", _hoisted_6, [
      _renderSlot(_ctx.$slots, "body", {}, undefined, true)
    ]),
    _createVNode("div", _hoisted_7, [
      _renderSlot(_ctx.$slots, "footer", {}, undefined, true)
    ])
  ]))
})